import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemRelationsMutation
 * @since 1.0.0
 */
export const ExportSaleItemRelationsMutation = gql `
  mutation ExportSaleItemRelationsMutation($input: ExportSaleItemRelationsInput!) {
    exportSaleItemRelations(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
